module.exports = __webpack_public_path__ + "static/media/en.ef9a2e3c.png";